const SKELETON_DEFAULT_IMG =
  "data:image/jpeg;base64,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";

var autocomplete;


var address1Field;

var postalField;

let showroomList;

let map;

let geocoder;

let isMapScriptLoaded = false;

const device = (() => {
  const userAgent = navigator?.userAgent || "";
  const screenWidth = window?.innerWidth || screen.width;
  const screenHeight = window?.innerHeight || screen.height;

  const isSamsung = /SamsungBrowser/i.test(userAgent);
  const isSafari =
    !isSamsung && /^((?!chrome|android).)*safari/i.test(userAgent);
  const isChrome =
    !isSamsung && !isSafari && /chrome|chromium|crios/i.test(userAgent);

  const isMobile =
    /iPhone|iPad|iPod|Android|Windows Phone/i.test(userAgent) ||
    screenWidth <= 768;
  const isDesktop = !isMobile;

  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isAndroid = /Android/i.test(userAgent) && !isIOS;

  return {
    isSamsung,
    isSafari,
    isChrome,
    isMobile,
    isDesktop,
    isIOS,
    isAndroid,
    screenWidth,
    screenHeight,
    userAgent,
  };
})();

function removeParamsFromImageUrl(url) {
  return url.replace(/\?.*$/, "");
}

const metersToMiles = (meters) => {
  console.log("metersToMiles:=================", meters);
  return meters * 0.000621371;
};

const waitForMapVariable = (
  callback,
  errorCallBack,
  interval = 64,
  timeout = 20000
) => {
  const startTime = Date.now();
  const timer = setInterval(() => {
    if (isMapScriptLoaded) {
      clearInterval(timer);
      setTimeout(() => {
        callback?.();
      }, 100);
    } else if (Date.now() - startTime > timeout) {
      clearInterval(timer);
      errorCallBack?.();
      console.warn("waitForVariable: 超时未检测到变量赋值");
    }
  }, interval);
};

/**
 * 地球半径直线距离
 */
const haversineDistance = (coord1, coord2) => {
  const R = 6371; // 地球半径 (km)
  const lat1 = (coord1.lat * Math.PI) / 180;
  const lat2 = (coord2.lat * Math.PI) / 180;
  const deltaLat = lat2 - lat1;
  const deltaLng = ((coord2.lng - coord1.lng) * Math.PI) / 180;

  const a =
    Math.sin(deltaLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

const inputElement = document.getElementById("ship-address");

const search = document.getElementById("search");

const handleDistance = async (lat, lng, showroomList) => {
  if (!(showroomList?.length > 0)) {
    return console.error("Error - 列表数据未加载 >>>>>>>>>>>>>>");
  }

  const bounds = new google.maps.LatLngBounds();

  const markersArray = [];

  const origins = showroomList.map((item) => ({
    lat: parseFloat(item.lat),
    lng: parseFloat(item.lng),
  }));

  const searchParams = new URLSearchParams(window.location.search || "");

  let queryAddress = {
    lat: lat || parseFloat(searchParams.get("lat")),
    lng: lng || parseFloat(searchParams.get("lng")),
  };

  if (!queryAddress || !queryAddress?.lat) {
    return console.error("Error -  没有经纬度 >>>>>>>>>>>>>>");
  }

  // 目标点 A 传入的搜索地址经纬度
  const destination = queryAddress;

  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  try {
    // 引入 RouteMatrix 和 AdvancedMarkerElement
    const { RouteMatrix } = await google.maps.importLibrary("routes");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    const chunks = chunkArray(origins, 25);

    let indexOffset = 0;

    // 标记目标点
    const destLatLng = new google.maps.LatLng(destination.lat, destination.lng);
    bounds.extend(destLatLng);
    markersArray.push(
      new AdvancedMarkerElement({
        map,
        position: destLatLng,
        content: document.createTextNode("D"),
      })
    );

    for (const chunk of chunks) {
      // 先为当前块的所有点添加标记并计算直线距离（作为保底）
      for (let i = 0; i < chunk.length; i++) {
        const globalIndex = indexOffset + i;
        const originLatLng = new google.maps.LatLng(chunk[i].lat, chunk[i].lng);

        bounds.extend(originLatLng);
        markersArray.push(
          new AdvancedMarkerElement({
            map,
            position: originLatLng,
            content: document.createTextNode("O"),
          })
        );

        // 默认使用直线距离
        const straightDistance = haversineDistance(queryAddress, {
          lat: Number(showroomList[globalIndex].lat),
          lng: Number(showroomList[globalIndex].lng),
        });
        showroomList[globalIndex].distance = straightDistance * 1000;
      }

      // 构造请求：使用标准的 LatLngLiteral 对象以避免类型错误
      const request = {
        origins: chunk.map((c) => ({ lat: parseFloat(c.lat), lng: parseFloat(c.lng) })),
        destinations: [{ lat: parseFloat(destination.lat), lng: parseFloat(destination.lng) }],
        travelMode: "DRIVING",
        // 使用 TRAFFIC_AWARE 最优路况计算，会请求最准确的路况信息，但计算时间稍长
        routingPreference: "TRAFFIC_AWARE_OPTIMAL",
        fields: [
          "distanceMeters",
          "originIndex",
          "destinationIndex",
          "condition",
        ],
      };

      try {
        const response = await RouteMatrix.computeRouteMatrix(request);
        // 解析响应：兼容多种可能的返回格式
        const elements = [];
        
        if (response && typeof response[Symbol.asyncIterator] === 'function') {
            // 异步迭代器格式
            for await (const element of response) {
                elements.push(element);
            }
        } else if (Array.isArray(response)) {
            // 直接数组格式
             elements.push(...response);
        } else if (response && Array.isArray(response.routeMatrixElements)) {
            // 包装对象格式
            elements.push(...response.routeMatrixElements);
        } else if (response && (response.matrix || response.rows)) {
             // 嵌套 Matrix 结构格式: { matrix: { rows: [{ items: [...] }] } }
             // 根据用户提供的 JSON，rows 数组中的对象包含 "items" 数组，而不是 "elements"
             const matrixObj = response.matrix || response;
             const rows = matrixObj.rows; 
             
             if (Array.isArray(rows)) {
                 rows.forEach((row, rIndex) => {
                     // 兼容 items (新版 REST) 或 elements (旧版)
                     const rowElements = row.items || row.elements || row; 
                     if (Array.isArray(rowElements)) {
                         rowElements.forEach((element, cIndex) => {
                             const dist = element.distanceMeters || element.distance?.value;
                             if (dist !== undefined) {
                                 elements.push({
                                     originIndex: rIndex,
                                     destinationIndex: cIndex,
                                     distanceMeters: dist,
                                     condition: element.condition
                                 });
                             }
                         });
                     }
                 });
             }
        } else {
             console.warn("Unexpected response format from computeRouteMatrix:", response);
             throw new Error("Response format not supported");
        }

        // 更新实际驾驶距离
        for (const element of elements) {
          if (element.originIndex !== undefined && element.distanceMeters) {
            const globalIndex = indexOffset + element.originIndex;
            if (showroomList[globalIndex]) {
              showroomList[globalIndex].distance = element.distanceMeters;
            }
          }
        }
      } catch (err) {
        console.warn(
          "Routes API request failed, keeping straight line distance:",
          err
        );
      }

      indexOffset += chunk.length;
    }

    map.fitBounds(bounds);

    const sortedList = showroomList.sort(function (a, b) {
      const distanceA = parseFloat(a.distance) || 0;
      const distanceB = parseFloat(b.distance) || 0;
      return distanceA - distanceB;
    });

    return sortedList || [];
  } catch (error) {
    console.error("Google Route Matrix 请求出错：", error);
  }
};

function initAutocomplete() {
  address1Field = document.querySelector("#ship-address");
  postalField = document.querySelector("#postcode");
  // Create the autocomplete object, restricting the search predictions to
  // addresses in the US and Canada.
  const pac = new google.maps.places.PlaceAutocompleteElement({
    includedRegionCodes: ["us"],
  });
  pac.id = address1Field.id;
  if (address1Field.className) pac.className = address1Field.className;
  if (address1Field.placeholder) pac.placeholder = address1Field.placeholder;
  
  address1Field.parentNode.insertBefore(pac, address1Field);
  
  address1Field.style.display = 'none';
  
  const searchParams = new URLSearchParams(window.location.search || "");
  const searchData = searchParams.get("searchData") || "";
  
  if (searchData) {
      pac.value = searchData;
      address1Field.value = searchData;
  }
  
  // Keep address1Field pointing to the hidden input for compatibility
  // address1Field = pac; 
  autocomplete = pac;

  // When the user selects an address from the drop-down, populate the
  // address fields in the form.
  pac.addEventListener("gmp-select", async ({ placePrediction  }) => {
    const place = placePrediction.toPlace();
    await place.fetchFields({ fields: ["addressComponents", "location"] });
    fillInAddress(place);
  });

  // 加载地图实例，用于搜索

  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: 39.8283, lng: -98.5795 }, // 中心点设在美国
    zoom: 15,
    mapId: "AWOL_VISION_SHOWROOM_MAP", // Required for AdvancedMarkerElement
  });

  geocoder = new google.maps.Geocoder();

  // service = new google.maps.DistanceMatrixService();

  isMapScriptLoaded = true;
}

async function fillInAddress(place) {
  if (!place) return;

  var address1 = "";

  var postcode = "";

  // Get each component of the address from the place details,
  // and then fill-in the corresponding field on the form.
  // place.addressComponents are AddressComponent objects
  for (const component of place.addressComponents || []) {
    // @ts-ignore remove once typings fixed
    const componentType = component.types[0];
    switch (componentType) {
      case "street_number": {
        address1 = `${component.longText} ${address1}`;
        break;
      }
      case "route": {
        address1 += component.shortText;
        break;
      }
      case "postal_code": {
        postcode = `${component.longText}${postcode}`;
        break;
      }
      case "postal_code_suffix": {
        postcode = `${postcode}-${component.longText}`;
        break;
      }
      case "locality":
        address1 += ` ${component.longText}`;
        document.querySelector("#locality").value = component.longText;
        break;
      case "administrative_area_level_1": {
        document.querySelector("#state").value = component.shortText;
        break;
      }
      case "country":
        // address1 += ` ${component.longText}`;
        document.querySelector("#country").value = component.longText;
        break;
      // 新增：处理 establishment 和 natural_feature 类型，提取其名称
      case "establishment": {
        // establishment 类型通常为商家、机构等，直接取名称
        if (component.longText) {
          address1 += ` ${component.longText}`;
        }
        break;
      }
      case "natural_feature": {
        // natural_feature 类型为自然地标，如湖泊、山脉等
        if (component.longText) {
          address1 += ` ${component.longText}`;
        }
        break;
      }
    }
  }
  address1Field.value = address1;

  postalField.value = postcode;

  let lat = place.location.lat();

  let lng = place.location.lng();

  // 先获取当前 URL
  const url = new URL(window.location);

  // 修改参数
  url.searchParams.set("lat", lat); // 比如把 ?key=value 加进去或者更新

  url.searchParams.set("lng", lng); // 比如把 ?key=value 加进去或者更新

  url.searchParams.set("searchData", address1); // 比如把 ?key=value 加进去或者更新

  window.history.pushState(
    { path: url.href }, // 保存状态
    "", // 标题（现代浏览器忽略）
    url.search // 新查询字符串
  );

  getData(lat, lng, 1, address1);
}

window.initAutocomplete = initAutocomplete;

/**
 *@懒加载图片
 */
const lazyLoadImages = () => {
  const lazyImages = document.querySelectorAll(
    ".visit_showroom_list img.lazy-image"
  );

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.onload = () => {
            img.classList.add("loaded");
          };

          // 加载失败处理
          img.onerror = () => {
            img.src = SKELETON_DEFAULT_IMG;
          };
          observer.unobserve(img);
        }
      });
    },
    {
      rootMargin: "0px 0px 100px 0px",
      threshold: 0.01,
    }
  );

  lazyImages.forEach((img) => {
    observer.observe(img);
  });
};

function getData(lat, lng, show) {
  $.ajax({
    // url: `https://${'admin.awolvision.com'}/prod-api/system/showrooms/list?pageSize=9`,
    url: `https://${
      window.adminBaseUrl || "admin.awolvision.com"
    }/prod-api/system/showrooms/list?pageSize=15`,
    type: "GET",
    dataType: "json",
    contentType: "application/json",
    data: {
      pageNum: 1,
      lat: lat,
      lng: lng,
      isShow: show,
    },
    success: function (response) {
      if (response.code !== 200) return;

      waitForMapVariable(
        async () => {
          const hasDistanceRows = await handleDistance(
            Number(lat),
            Number(lng),
            response.rows
          );
          // 只取前5条数据
          const topRows = hasDistanceRows.slice(0, 9);
          let htmls = "";

          for (const row of topRows) {
            if (row.isShow != 1) continue;

            const { id, city, state, type, tile, distance, photoList } = row;

            let image_url =
              photoList && photoList.length > 0
                ? removeParamsFromImageUrl(photoList[0].url)
                : "https://cdn.shopify.com/s/files/1/0554/7445/4576/files/thunder_room_swiper_image01.png?v=1727166601";

            let distanceStr = "";

            const numericDistance = Number(distance);

            if (numericDistance <= 0) {
              distanceStr = numericDistance.toFixed(2) + "m";
            } else {
              // 确保 distance 是米，并转换为英里
              distanceStr = metersToMiles(numericDistance).toFixed(2) + "mi";
            }

            const typeLabel = type == 1 ? "Community Showroom" : "Retail";

            htmls += `
                    <div class="list_item">
                      <a class="card_link" href="https://awolvision.com/pages/showroom-details?id=${id}&distance=${distanceStr}">
                         <img  src="${SKELETON_DEFAULT_IMG}" loading="lazy" data-src="${image_url}" alt="" class="lazy-image"  onerror="this.onerror=null; this.src='${SKELETON_DEFAULT_IMG}'" />
                        <div class="item_margin item_subtitle">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.125 7.375C3.125 4.675 5.3 2.5 8 2.5C10.7 2.5 12.875 4.675 12.875 7.375C12.875 11.0428 9.40921 13.5908 8.32211 14.2999C8.12505 14.4284 7.87494 14.4284 7.67788 14.2999C6.59078 13.5908 3.125 11.0428 3.125 7.375ZM5.75 7.37565C5.75 6.13815 6.7625 5.12565 8 5.12565C9.2375 5.12565 10.25 6.13815 10.25 7.37565C10.25 8.61314 9.2375 9.62564 8 9.62564C6.7625 9.62564 5.75 8.61314 5.75 7.37565Z" fill="currentColor"/>
                          </svg>
                          <span class="item_distance">${distanceStr}</span> | ${city}, ${state}</div>
                        <div class="item_margin item_desc">${typeLabel}</div>
                        <div class="item_margin item_title">${tile}</div>
                        <div class="item_margin link_to">
                          <span class="link--animated">VIEW SHOWROOM</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path d="M13.1558 10.4402L7.51997 16.25L6.66602 15.3697L11.8749 10L6.66602 4.63032L7.51998 3.75L13.1558 9.55984C13.3916 9.80293 13.3916 10.1971 13.1558 10.4402Z" fill="currentColor"/>
                          </svg>
                        </div>
                      </a>
                    </div>
                  `;
          }

          //覆盖元素里面的所有东西，所以不需要重置
          $(".visit_showroom_list").html(htmls);

          // 跳转到列表页时，滚动到上次点击的元素位置
          if (!device.isIOS) {
            const distanceFromHeader =
              localStorage.getItem("distanceFromHeader");

            if (distanceFromHeader && !isNaN(distanceFromHeader)) {
              $("html, body").animate({ scrollTop: distanceFromHeader }, 0);
              localStorage.removeItem("distanceFromHeader");
            }
          }

          lazyLoadImages();
        },
        () => {
          console.error("Error - 等待地图脚本加载失败 >>>>>>>>>>>>>>");
        }
      );
    },
    error: function (xhr, status, error) {
      // 请求失败时的回调函数
      console.error("Error: 列表请求 api 失败", error);
    },
  });
}

const searchParams = new URLSearchParams(window.location.search || "");

document.getElementById("ship-address").value =
  searchParams.get("searchData") || "";

$(function () {
  let lat = shopCommon.getQueryParams("lat");

  let lng = shopCommon.getQueryParams("lng");

  let show = shopCommon.getQueryParams("isShow");

  if (lat && lng) {
    getData(lat, lng, show);
  } else {
    getData();
  }

  $(document).on("click", ".list_item", function () {
    const headerOffsetTop = $(".visit_showroom_header").offset().top;
    const elementOffsetTop = $(this).offset().top;
    const distanceFromHeader = elementOffsetTop - headerOffsetTop;
    localStorage.setItem("distanceFromHeader", distanceFromHeader);
  });
});

window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    if (device.isIOS) {
      setTimeout(() => {
        const searchParams = new URLSearchParams(window.location.search || "");

        document.getElementById("ship-address").value =
          searchParams.get("searchData") || "";

        const distanceFromHeader = localStorage.getItem("distanceFromHeader");

        if (distanceFromHeader && !isNaN(distanceFromHeader)) {
          $("html, body").animate({ scrollTop: distanceFromHeader }, 0);
          localStorage.removeItem("distanceFromHeader");
        }
      }, 100);
    }
  }
});
